export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6673.50795d1d.jpg";